export default {
  name: 're-content-sections',
  props: {
    sections: {
      type: [Array, Object]
    },
    component: {
      type: String,
      default: 're-group-box'
    },
    itemComponent: {
      type: String,
      default: 're-blank-component'
    }
  },
  computed: {
    sectionComponent() {
      return this.component || 're-blank-component'
    },
    sectionItemComponent() {
      return this.itemComponent || 're-blank-component'
    },
    isGroupBox() {
      return this.sectionComponent === 're-group-box'
    },
  }
}
